import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/sweet/code.png';
const _hoisted_1 = {
  class: "example"
};
const _hoisted_2 = {
  class: "code-action"
};
const _hoisted_3 = {
  class: "example"
};
import { DEMO_PAGE_URL } from '@/api/demo/demo';
const code = `
<XTable
  :url="DEMO_PAGE_URL"
  :column="[
    { label: '用户名', prop: 'username' },
    { label: '性别', prop: 'gender' },
    { label: '手机号码', prop: 'phoneNumber' }
  ]">
</XTable>
`;
// const decoded = computed(() => {
//   return decodeURIComponent('')
// })
export default /*@__PURE__*/_defineComponent({
  __name: 'XTableExample',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_XTable = _resolveComponent("XTable");
      const _component_highlightjs = _resolveComponent("highlightjs");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", null, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "title"
      }, [_createElementVNode("h2", null, "基本使用")], -1)), _createElementVNode("div", _hoisted_1, [_createVNode(_component_XTable, {
        url: _unref(DEMO_PAGE_URL),
        column: [{
          label: '用户名',
          prop: 'username'
        }, {
          label: '性别',
          prop: 'gender'
        }, {
          label: '手机号码',
          prop: 'phoneNumber'
        }]
      }, null, 8, ["url"])]), _createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("header", null, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })], -1)), _createVNode(_component_highlightjs, {
        language: "vue",
        code: code
      }), _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1))])]), _createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "title"
      }, [_createElementVNode("h2", null, "数据过滤")], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_XTable, {
        url: _unref(DEMO_PAGE_URL),
        "data-filter": data => data.filter(item => item.gender === 'F'),
        column: [{
          label: '用户名',
          prop: 'username'
        }, {
          label: '性别',
          prop: 'gender'
        }, {
          label: '手机号码',
          prop: 'phoneNumber'
        }]
      }, null, 8, ["url", "data-filter"])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "code-action"
      }, [_createElementVNode("header", null, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })])], -1))])]);
    };
  }
});